// Environment Configuration
import { EnvironmentConfig } from '../types';

// Declare process for TypeScript (provided by react-scripts)
declare const process: {
  env: {
    NODE_ENV?: string;
    [key: string]: string | undefined;
  };
};

const config: Record<string, EnvironmentConfig> = {
  development: {
    NODE_ENV: 'development',
    REACT_APP_ENV: 'development',
    REACT_APP_NAME: 'CPFGS CMS (Dev)',
    REACT_APP_VERSION: '1.0.2',
    REACT_APP_DESCRIPTION: 'CPFGS Web Application - Development Mode',
    REACT_APP_API_URL: 'https://cpfgs-lineoa-smartpc-api-dev.eggdigital.com/api',
    REACT_APP_API_TIMEOUT: 10000,
    REACT_APP_ENABLE_DEBUG: true,
    REACT_APP_ENABLE_ANALYTICS: false,
    REACT_APP_ENABLE_HOT_RELOAD: true,
    REACT_APP_THEME: 'default',
    REACT_APP_LANGUAGE: 'th',
    REACT_APP_SHOW_DEV_TOOLS: true,
    REACT_APP_LOG_LEVEL: 'debug'
  },
  production: {
    NODE_ENV: 'production',
    REACT_APP_ENV: 'production',
    REACT_APP_NAME: 'CPFGS CMS',
    REACT_APP_VERSION: '1.0.2',
    REACT_APP_DESCRIPTION: 'CPFGS Web Application',
    REACT_APP_API_URL: 'https://cpfgs-lineoa-smartpc-api.eggdigital.com/api',
    REACT_APP_API_TIMEOUT: 15000,
    REACT_APP_ENABLE_DEBUG: false,
    REACT_APP_ENABLE_ANALYTICS: true,
    REACT_APP_ENABLE_HOT_RELOAD: false,
    REACT_APP_THEME: 'default',
    REACT_APP_LANGUAGE: 'th',
    REACT_APP_SHOW_DEV_TOOLS: false,
    REACT_APP_LOG_LEVEL: 'error'
  },
  test: {
    NODE_ENV: 'test',
    REACT_APP_ENV: 'test',
    REACT_APP_NAME: 'CPFGS Web (Test)',
    REACT_APP_VERSION: '1.0.0',
    REACT_APP_DESCRIPTION: 'CPFGS Web Application - Test Mode',
    REACT_APP_API_URL: 'http://localhost:8080/api',
    REACT_APP_API_TIMEOUT: 5000,
    REACT_APP_ENABLE_DEBUG: true,
    REACT_APP_ENABLE_ANALYTICS: false,
    REACT_APP_ENABLE_HOT_RELOAD: false,
    REACT_APP_THEME: 'default',
    REACT_APP_LANGUAGE: 'th',
    REACT_APP_SHOW_DEV_TOOLS: false,
    REACT_APP_LOG_LEVEL: 'warn'
  }
};

// Get current environment
const env: string = process.env.NODE_ENV || 'production';

// Export configuration for current environment
const currentConfig = config[env] || config['production'];

// Debug logging (only in development or if explicitly enabled)
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENABLE_DEBUG === 'true') {
  console.log("---------Environment Config---------")
  console.log("Environment:", env)
  console.log("API URL:", currentConfig.REACT_APP_API_URL)
  console.log("------------------------------------")
}

export default currentConfig;

// Export all configurations
export { config };